import {FormControl, FormHelperText, FormLabel, Input} from "@mui/joy";
import {Controller, useFormContext} from "react-hook-form";

export function FormOptionalNumericInput({ name, label, size, placeholder, variant='outlined', inputProps, endDecorator, sx }) {
  const { control, formState, getFieldState } = useFormContext();    
  const error = getFieldState(name, formState).error;

  return (
    <FormControl error={!!error} sx={sx}>
      {label && <FormLabel>{label} <span style={{ color: 'var(--joy-palette-neutral-400)' }}>(optional)</span></FormLabel>}
      <Controller
        name={name}
        control={control}
        render={({ field: { ref, onBlur, ...field } }) => {
          const handleChange = (e) => {
            const inputValue = e.target.value;
            if (inputValue === '' || inputValue === null || inputValue === undefined) {
              field.onChange(null);
            } else {
              const numValue = parseFloat(inputValue);
              if (!isNaN(numValue)) {
                field.onChange(numValue);
              } else {
                field.onChange(inputValue);
              }
            }
          };

          const displayValue = field.value === null || field.value === undefined ? '' : field.value;

          return (
            <Input 
              ref={ref}
              value={displayValue}
              onChange={handleChange}
              onBlur={onBlur}
              type="number" 
              size={size} 
              variant={variant} 
              placeholder={placeholder} 
              slotProps={inputProps ? {input: inputProps} : undefined} 
              endDecorator={endDecorator} 
            />
          );
        }}
      />
      {error && <FormHelperText sx={{ ml: variant === 'plain' ? 1.5 : 0 }}>{error.message}</FormHelperText>}
    </FormControl>
  );
}

